import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  getBigIntHashCode294hi5bdhtj6e as getBigIntHashCode,
} from '../js/coreRuntime.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../Unit.mjs';
import {
  getLongAt2xo9o2feqbs0 as getLongAt,
  uuidParseHexDash18eiuoxladbda as uuidParseHexDash,
  uuidParseHex3eqot5o6m8iet as uuidParseHex,
  formatBytesInto37zm00l0btni2 as formatBytesInto,
  secureRandomBytes2zvo6sd7seuw0 as secureRandomBytes,
} from './UuidJs.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import {
  _Char___init__impl__6a9atx2gndcvjvc5pke as _Char___init__impl__6a9atx,
  Char__toInt_impl_vasixdnyockrdnmht5 as Char__toInt_impl_vasixd,
  toString22rbkbhdb5cl2 as toString_0,
} from '../Char.mjs';
import { toByte4i43936u611k as toByte } from '../js/numberConversion.mjs';
import {
  decodeToString1x4faah2liw2p as decodeToString,
  substringiqarkczpya5m as substring,
} from '../text/stringJs.mjs';
import {
  _ULong___init__impl__c78o9k4z3cjzifecv6 as _ULong___init__impl__c78o9k,
  _ULong___get_data__impl__fggpzb2bbucljk081qt as _ULong___get_data__impl__fggpzb,
} from '../ULong.mjs';
import { ulongCompare29yg6v52hxi4l as ulongCompare } from '../UnsignedJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from '../Comparable.mjs';
import { joinToString26w4x2pxjux6a as joinToString } from '../collections/_Arrays.mjs';
import { charCodeAt1yspne1d8erbm as charCodeAt } from '../js/charSequenceJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.hi_1 = new (Uuid())(0n, 0n);
        this.ii_1 = 16;
        this.ji_1 = 128;
      }
      ki(mostSignificantBits, leastSignificantBits) {
        var tmp;
        if (mostSignificantBits === 0n && leastSignificantBits === 0n) {
          tmp = this.hi_1;
        } else {
          tmp = new (Uuid())(mostSignificantBits, leastSignificantBits);
        }
        return tmp;
      }
      ft(byteArray) {
        // Inline function 'kotlin.require' call
        if (!(byteArray.length === 16)) {
          var message = 'Expected exactly 16 bytes, but was ' + truncateForErrorMessage(byteArray, 32) + ' of size ' + byteArray.length;
          throw IllegalArgumentException().n2(toString(message));
        }
        return this.ki(getLongAt(byteArray, 0), getLongAt(byteArray, 8));
      }
      gt(uuidString) {
        var tmp;
        switch (uuidString.length) {
          case 36:
            tmp = uuidParseHexDash(uuidString);
            break;
          case 32:
            tmp = uuidParseHex(uuidString);
            break;
          default:
            throw IllegalArgumentException().n2('Expected either a 36-char string in the standard hex-and-dash UUID format or a 32-char hexadecimal string, ' + ('but was "' + truncateForErrorMessage_0(uuidString, 64) + '" of length ' + uuidString.length));
        }
        return tmp;
      }
      ht() {
        return this.it();
      }
      it() {
        return secureRandomUuid();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var UuidClass;
function Uuid() {
  if (UuidClass === VOID) {
    class $ {
      constructor(mostSignificantBits, leastSignificantBits) {
        Companion_getInstance();
        this.jt_1 = mostSignificantBits;
        this.kt_1 = leastSignificantBits;
      }
      toString() {
        return this.lt();
      }
      lt() {
        var bytes = new Int8Array(36);
        formatBytesInto(this.jt_1, bytes, 0, 0, 4);
        // Inline function 'kotlin.code' call
        var this_0 = _Char___init__impl__6a9atx(45);
        var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
        bytes[8] = toByte(tmp$ret$0);
        formatBytesInto(this.jt_1, bytes, 9, 4, 6);
        // Inline function 'kotlin.code' call
        var this_1 = _Char___init__impl__6a9atx(45);
        var tmp$ret$1 = Char__toInt_impl_vasixd(this_1);
        bytes[13] = toByte(tmp$ret$1);
        formatBytesInto(this.jt_1, bytes, 14, 6, 8);
        // Inline function 'kotlin.code' call
        var this_2 = _Char___init__impl__6a9atx(45);
        var tmp$ret$2 = Char__toInt_impl_vasixd(this_2);
        bytes[18] = toByte(tmp$ret$2);
        formatBytesInto(this.kt_1, bytes, 19, 0, 2);
        // Inline function 'kotlin.code' call
        var this_3 = _Char___init__impl__6a9atx(45);
        var tmp$ret$3 = Char__toInt_impl_vasixd(this_3);
        bytes[23] = toByte(tmp$ret$3);
        formatBytesInto(this.kt_1, bytes, 24, 2, 8);
        return decodeToString(bytes);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Uuid()))
          return false;
        return this.jt_1 === other.jt_1 && this.kt_1 === other.kt_1;
      }
      mt(other) {
        var tmp;
        if (!(this.jt_1 === other.jt_1)) {
          // Inline function 'kotlin.toULong' call
          var this_0 = this.jt_1;
          var tmp0 = _ULong___init__impl__c78o9k(this_0);
          // Inline function 'kotlin.toULong' call
          var this_1 = other.jt_1;
          // Inline function 'kotlin.ULong.compareTo' call
          var other_0 = _ULong___init__impl__c78o9k(this_1);
          tmp = ulongCompare(_ULong___get_data__impl__fggpzb(tmp0), _ULong___get_data__impl__fggpzb(other_0));
        } else {
          // Inline function 'kotlin.toULong' call
          var this_2 = this.kt_1;
          var tmp0_0 = _ULong___init__impl__c78o9k(this_2);
          // Inline function 'kotlin.toULong' call
          var this_3 = other.kt_1;
          // Inline function 'kotlin.ULong.compareTo' call
          var other_1 = _ULong___init__impl__c78o9k(this_3);
          tmp = ulongCompare(_ULong___get_data__impl__fggpzb(tmp0_0), _ULong___get_data__impl__fggpzb(other_1));
        }
        return tmp;
      }
      d(other) {
        return this.mt(other instanceof Uuid() ? other : THROW_CCE());
      }
      hashCode() {
        return getBigIntHashCode(this.jt_1 ^ this.kt_1);
      }
    }
    initMetadataForClass($, 'Uuid', VOID, VOID, [Comparable()]);
    UuidClass = $;
  }
  return UuidClass;
}
function truncateForErrorMessage(_this__u8e3s4, maxSize) {
  return joinToString(_this__u8e3s4, VOID, '[', ']', maxSize);
}
function truncateForErrorMessage_0(_this__u8e3s4, maxLength) {
  return _this__u8e3s4.length <= maxLength ? _this__u8e3s4 : substring(_this__u8e3s4, 0, maxLength) + '...';
}
function secureRandomUuid() {
  // Inline function 'kotlin.also' call
  var this_0 = new Int8Array(16);
  secureRandomBytes(this_0);
  return uuidFromRandomBytes(this_0);
}
function uuidFromRandomBytes(randomBytes) {
  randomBytes[6] = toByte(randomBytes[6] & 15);
  randomBytes[6] = toByte(randomBytes[6] | 64);
  randomBytes[8] = toByte(randomBytes[8] & 63);
  randomBytes[8] = toByte(randomBytes[8] | 128);
  return Companion_getInstance().ft(randomBytes);
}
function uuidThrowUnexpectedCharacterException(inputString, errorDescription, errorIndex) {
  throw IllegalArgumentException().n2('Expected ' + errorDescription + ' at index ' + errorIndex + ", but was '" + toString_0(charCodeAt(inputString, errorIndex)) + "'");
}
//region block: exports
export {
  Companion_getInstance as Companion_getInstance1bxbth0yni76u,
  Uuid as Uuid1zxgztb7abqxx,
  uuidThrowUnexpectedCharacterException as uuidThrowUnexpectedCharacterException3et7vw31qdgo4,
};
//endregion

//# sourceMappingURL=Uuid.mjs.map
